export enum ArticleType {
  HORIZONTAL = 'horizontal',
  VERICAL = 'vertical',
}
export interface IArticle {
  type: ArticleType;
  image: {
    path: string;
    alt: string;
  };
  tag: string;
  title: string;
  text: string;
  href: string;
  list: {
    text: string;
  }[];
}
